import DwinityLoader from "../components/DwinityLoader";
import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from 'react-i18next';
import FileUploadComponent from "../components/FileUploadComponent";
import { AppContext } from "../AppContextProvider";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
import { dataimportJwt } from "../utils/dataimport/dwdataimport";
import { loadJwt } from "../utils/dwclient/localstorage/jwtStorage";
import { FileUnzipError } from "../utils/dwclient/dwstorage";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
} from "mdb-react-ui-kit";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";
import { isZipFileContent } from "../utils/zip/unzipper";
import { formatTimeHHMMSS } from "../utils/paths";

export default function DataimportModal(props) {
  const { t } = useTranslation();
  const basicRef = useRef(null);
  const { selectedAccount, selectedWallet } = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const context = useContext(AppContext);
  const [isFiles, setIsFiles] = useState(false);
  const [files, setFiles] = useState([]);
  const [isVisibility5, setIsVisibility5] = useState(false);
  const [bar, setBar] = useState(document.getElementById("progress-bar"));
  const [size, setSize] = useState(document.getElementById("file-size"));
  const [details, setDetails] = useState(document.getElementById("file-details"));
  const [timer, setTimer] = useState(document.getElementById("file-timer"));
  const [timertext, setTimertext] = useState(document.getElementById("file-timer-text"));

  const maxUploadSize = process.env.MAX_UPLOAD_SIZE ?? 536870912;

  function onUploadProgress(progressEvent) {
    const percentCompleted = (progressEvent.loaded / progressEvent.total) * 100;
    const sizeCompleted = ((progressEvent.loaded / progressEvent.total) * files[0].size) / 1e6;
    if (bar) bar.style.width = `${percentCompleted}%`;
    const barLabel = document.getElementById("progress-bar-label");
    if (barLabel) barLabel.textContent = `${percentCompleted.toFixed(0)}%`;
    size.textContent = `${sizeCompleted.toFixed(2)}MB of ` + `${(files[0].size / 1e6).toFixed(2)}MB`;
    if (progressEvent.estimated !== undefined) {
      timertext.textContent = t('files.upload.timeRemaining');
      timer.textContent = formatTimeHHMMSS(progressEvent.estimated);
    }
    if (percentCompleted === 100) {
      if (barLabel) barLabel.textContent = t('files.upload.uploadComplete');
      details.textContent = t('files.upload.fileProcessing');
    }
  }

  const uploadFiles = async () => {
    if (files.length > 0 && files.length > files.filter((k) => k.isDelete).length) {
      //setIsVisibility5(true);

      const errors = [];
      for (let i = 0; i < files.length; i++) {
        try {
          if (!files[i].isDelete) {
            var file = files[i];
            if (!(await isZipFileContent(file))) {
              throw new FileUnzipError(file.name);
            }
            delete file.isDelete;

            props.hideModal();
            await uploadSingleFile(file);
          }
        } catch (error) {
          errors.push(error.message);
        }
      }
      if (errors.length > 0) {
        console.log("Errors: " + errors);
        if (props.modalParam?.onError) {
          props.modalParam.onError("Errors: " + errors);
        }
        return;
      }

      setFiles([]);
      setTimeout(() => {
        props.modalParam.onFinish();
        //setIsVisibility5(false);
        //props.hideModal();

        context.onSetIsRender();
      }, 500);
    }
  };

  const uploadSingleFile = async (file) => {
    if (selectedAccount !== null && file !== null) {
      if (file.size > 0) {
        const authToken = await loadJwt();
        await dataimportJwt(selectedWallet?.provider, authToken, "amazon", file, onUploadProgress);
        //setIsVisibility5(true);
      }
    }
  };

  useEffect(() => {
    if (isFiles && context.getState()?.isProgress) {
      setBar(document.getElementById("progress-bar"));
      setSize(document.getElementById("file-size"));
      setDetails(document.getElementById("file-details"));
      setTimer(document.getElementById("file-timer"));
      setTimertext(document.getElementById("file-timer-text"));
    }
  }, [context.getState()?.isProgress]);

  useEffect(() => {
    if (bar !== null) {
      uploadFiles();
    }
  }, [bar]);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="file-upload-modal">
        <MDBModalDialog scrollable centered size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="title-text">{t('modals.importFiles.title')}</div>
              <button
                type="button"
                className="button subtle medium"
                onClick={() => props.hideModal()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="#D7DAE7"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="fileupload-div">
                <div className="file-upload-div">
                  <div className="fake-select-menu">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.5049 13H3.49508C3.09846 12.9992 2.71833 12.8411 2.43807 12.5605C2.1578 12.2799 2.00026 11.8995 2 11.5029V4.49707C2.00088 4.09979 2.1593 3.71907 2.44049 3.43842C2.72169 3.15778 3.10272 3.00011 3.5 3H6.5C6.81011 3.00026 7.11254 3.09654 7.36574 3.27559C7.61893 3.45465 7.81049 3.7077 7.91408 4H12.5088C12.9049 4.00127 13.2843 4.15958 13.5639 4.44023C13.8435 4.72088 14.0003 5.10095 14 5.49707V11.5029C13.9997 11.8995 13.8422 12.2799 13.5619 12.5605C13.2816 12.8412 12.9015 12.9992 12.5049 13ZM3.5 4C3.36782 3.99976 3.24095 4.05195 3.14721 4.14514C3.05347 4.23833 3.00053 4.36489 3 4.49707V11.5029C2.99976 11.6345 3.05178 11.7607 3.14462 11.854C3.23746 11.9472 3.36352 11.9997 3.49508 12H12.5049C12.6359 11.9981 12.761 11.945 12.8535 11.8521C12.946 11.7593 12.9986 11.634 13 11.5029V5.49707C12.9991 5.36652 12.9473 5.24147 12.8555 5.14861C12.7637 5.05575 12.6393 5.00242 12.5088 5H7.5C7.43433 5.00004 7.36929 4.98714 7.30861 4.96203C7.24793 4.93691 7.19279 4.90008 7.14635 4.85365C7.09992 4.80721 7.06309 4.75207 7.03797 4.69139C7.01286 4.63071 6.99996 4.56567 7 4.5C7.0007 4.43415 6.98824 4.36882 6.96336 4.30784C6.93848 4.24686 6.90167 4.19146 6.8551 4.1449C6.80854 4.09833 6.75314 4.06152 6.69216 4.03664C6.63119 4.01176 6.56585 3.9993 6.5 4H3.5Z"
                        fill="var(--text-accent-tertiary)"
                      />
                    </svg>
                    <span>/ User Files / Imported / </span>
                  </div>

                  <FileUploadComponent
                    setIsFiles={(value) => setIsFiles(value)}
                    setFiles={(files) => setFiles(files)}
                    files={files}
                    dataimport={true}
                  />
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <div className="actions-button-div-upload">
                <button
                  className="button subtle medium "
                  onClick={() => {
                    props.hideModal();
                  }}
                >
                  <span className="text">{t('common.buttons.cancel')}</span>
                </button>
                <button
                  className="button brand medium "
                  disabled={!isFiles}
                  onClick={() => {
                    context.isProgress(true);
                    /*
                    if (files[0].size > maxUploadSize) {
                      if (props.modalParam?.onError) {
                        props.modalParam.onError(
                          "The maximum allowed file size: " + (maxUploadSize / 1e6).toFixed(2) + "MB",
                        );
                      }
                    } else {
                      context.isProgress(true);
                    }
                      */
                  }}
                >
                  <span className="text">{t('common.buttons.import')}</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      {isVisibility5 && <DwinityLoader />}
    </>
  );
}
